import { Role } from "../../types/role";

const MEZun: Role = {
  primary: [
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Entscheidungen",
    "OhneBall",
    "Antritt",
  ],
  secondary: [
    "Ballannahme",
    "Dribbling",
    "Tackling",
    "Weitschuesse",
    "Antizipation",
    "Nervenstaerke",
    "Uebersicht",
    "Ausdauer",
    "Balance",
  ],
  physis: "mittelfeld",
};

const MEZan: Role = {
  primary: [
    "Dribbling",
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Entscheidungen",
    "OhneBall",
    "Uebersicht",
    "Antritt",
  ],
  secondary: [
    "Abschluss",
    "Ballannahme",
    "Weitschuesse",
    "Antizipation",
    "Flair",
    "Nervenstaerke",
    "Ausdauer",
    "Balance",
  ],
  physis: "mittelfeld",
};

export const MEZ = {
  MEZun,
  MEZan,
};
